import styled from 'styled-components';
import { styles } from '../../../../../consts';

const { fontMBank, greenPrimary } = styles;

export const ButtonWrapper = styled.div`
  text-align: center;
  align-items: center;
  display: flex;
  margin: auto;
  justify-content: center;

  img {
    width: 1rem;
    height: 1rem;
  }
`;

export const ExpandButton = styled.button`
  position: relative;
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.125rem;
  font-family: ${fontMBank};
  outline: none;
  cursor: pointer;
  white-space: nowrap;
  padding: 0.625rem 0.125rem 0.625rem 0.225rem;
  height: 2.5rem;
  overflow: unset;
  color: ${greenPrimary};
  background-color: #ffffff;
`;
